import {GA_FAILURE, GA_SUCCESS, GNI_SUCCESS, GNI_PENDING, DI_SUCCESS} from './constants'
import {getAudit as getAuditAPI} from '../../../services/audits'
import {getAuditItems as getItemsAPI} from '../../../services/audits'

export async function getAudit(data, reload, params, dispatch) {
  dispatch({type: GA_SUCCESS, payload: data})
  if (reload) {
    try {
      let id = data.id
      let response = await getAuditAPI(id, params)
      dispatch({type: GA_SUCCESS, payload: response})
      return response
    } catch (e) {
      console.log(`Get Audit Failed: ${data.id}`)
      dispatch({type: GA_FAILURE, payload: e})
      return e.response
    }
  }
}

export async function getNextPageItems(id, params = {}, dispatch) {
  dispatch({type: GNI_PENDING, payload: []})
  try {
    let response = await getItemsAPI(id, params)
    dispatch({type: GNI_SUCCESS, payload: response})
    dispatch({type: DI_SUCCESS, payload: 'loading'})
    return response
  } catch (e) {
    console.log(`Get Audit Items Failed`)
    dispatch({type: DI_SUCCESS, payload: 'loading'})
    return e.response
  }
}
